<script lang="ts">
  import cn from 'classnames'
  import css from '../../../../css/comments.pcss.json'
  import type { CommentAttachment } from "../../comments/CommentTypes";
  import AttachmentEditable from "./AttachmentEditable.svelte";

  export let attachments: CommentAttachment[]
  export let removeAttachment: (index: number) => void

  let linkAttachments: CommentAttachment[] = []
  let mediaAttachments: CommentAttachment[] = []
  let gameAttachments: CommentAttachment[] = []
  let onlyOneLink: boolean = false
  let onlyOneMedia: boolean = false
  let onlyOneGame: boolean = false
  $: {
    attachments = attachments.map(attachment => {
      const previewUrl = attachment.preview_url
      if (typeof previewUrl === 'string' && !previewUrl.startsWith('data:image/')) {
        const matches = previewUrl.matchAll(/\/\//g)
        if (matches) {
          const realMatches = [...matches]
          if (realMatches.length > 1) {
            attachment.preview_url = previewUrl.substring(previewUrl.indexOf('//', 7))
          }
        }
      }
      return attachment
    })

    linkAttachments = attachments.filter(attachment => ['link', 'website'].includes(attachment.type))
    mediaAttachments = attachments.filter(attachment => ['image', 'video'].includes(attachment.type))
    gameAttachments = attachments.filter(attachment => attachment.type === 'game')
    onlyOneLink = linkAttachments.length === 1
    onlyOneMedia = mediaAttachments.length === 1
    onlyOneGame = gameAttachments.length === 1
  }
</script>

{#if linkAttachments.length > 0}
    <section
        class={cn({
      [css['comment__attachments']]: true,
      [css['comment__attachments--editable']]: true,
    })}
    >
        {#each linkAttachments as attachment (attachment.UUID)}
            <AttachmentEditable
                attachment={attachment}
                onlyAttachment={onlyOneLink}
                removeAttachment={() => removeAttachment(attachment.UUID)}
            />
        {/each}
    </section>
{/if}

{#if mediaAttachments.length > 0}
    <section
        class={cn({
      [css['comment__attachments']]: true,
      [css['comment__attachments--images']]: true,
      [css['comment__attachments--editable']]: true,
    })}
    >
        {#each mediaAttachments as attachment (attachment.UUID)}
            <AttachmentEditable
                attachment={attachment}
                onlyAttachment={onlyOneMedia}
                removeAttachment={() => removeAttachment(attachment.UUID)}
            />
        {/each}
    </section>
{/if}

{#if gameAttachments.length > 0}
    <section
        class={cn({
      [css['comment__attachments']]: true,
      [css['comment__attachments--games']]: true,
      [css['comment__attachments--editable']]: true,
    })}
    >
        {#each gameAttachments as attachment (attachment.UUID)}
            <AttachmentEditable
                attachment={attachment}
                onlyAttachment={onlyOneGame}
                removeAttachment={() => removeAttachment(attachment.UUID)}
            />
        {/each}
    </section>
{/if}
